export default __webpack_public_path__ + "static/media/compassbtniconseleted.3420bf51.svg";